
import React from 'react';
import { GameMetadata } from '../types';

interface GameCardProps {
  game: GameMetadata;
  onClick: (id: string) => void;
}

const GameCard: React.FC<GameCardProps> = ({ game, onClick }) => {
  return (
    <button
      onClick={() => onClick(game.id)}
      className="group relative flex flex-col items-start p-6 rounded-[1.5rem] bg-slate-900/40 border border-white/10 transition-all duration-300 hover:bg-slate-900/80 hover:border-blue-500/50 hover:-translate-y-2 hover:shadow-2xl hover:shadow-blue-500/20 text-left overflow-hidden w-full h-full"
    >
      {/* Decorative Blur */}
      <div className={`absolute -top-10 -right-10 w-32 h-32 rounded-full blur-[40px] opacity-10 transition-opacity group-hover:opacity-30 ${game.color}`}></div>
      
      <div className="flex items-center gap-4 mb-4 relative z-10">
        <div className={`w-14 h-14 rounded-2xl glass flex items-center justify-center text-3xl shadow-xl transition-transform group-hover:scale-110`}>
          {game.icon}
        </div>
        <div>
          <h3 className="text-xl font-black text-white leading-tight tracking-tighter group-hover:text-blue-400 transition-colors">
            {game.title}
          </h3>
          <span className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-600">
            {game.category}
          </span>
        </div>
      </div>

      <p className="text-slate-400 text-sm font-medium leading-relaxed mb-6 flex-1 relative z-10">
        {game.description}
      </p>

      <div className="w-full flex items-center justify-between pt-4 border-t border-white/5 relative z-10">
        <span className="text-[9px] font-black text-slate-500 uppercase tracking-widest group-hover:text-blue-500 transition-colors">Launch Module</span>
        <div className="w-6 h-6 rounded-full bg-white/5 flex items-center justify-center text-[10px] group-hover:bg-blue-600 group-hover:text-white transition-all">
          →
        </div>
      </div>
    </button>
  );
};

export default GameCard;
